import React from 'react';
import { InstagramIcon, MailIcon, GlobeIcon } from 'lucide-react';
import { INSTAGRAM_URL, SUPPORT_EMAIL, WEBSITE_URL } from '../data/contact';
const links = [{
  icon: MailIcon,
  label: SUPPORT_EMAIL,
  href: `mailto:${SUPPORT_EMAIL}`,
  external: false
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  href: INSTAGRAM_URL,
  external: true
}, {
  icon: GlobeIcon,
  label: 'Oficjalna strona',
  href: WEBSITE_URL,
  external: true
}];
export function SiteFooter() {
  return <footer className="border-t border-night-600 bg-night-950 py-12 sm:py-14" data-id="element-326" data-mp="3dei4m2d3jdlr">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-327" data-mp="38ggl5gbrdc9r">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-328" data-mp="33hvkxgwiaslb">
          <div className="max-w-md" data-id="element-329" data-mp="2yk3vqun8xkkt">
            <p className="font-display text-2xl leading-tight text-cream" data-id="element-330" data-mp="2yl577086c932">
              Arsenał Nauczyciela <span className="text-amber" data-id="element-331" data-mp="11qs8cm3233y4">Jazzu&trade;</span>
            </p>
            <p className="mt-2 text-sm text-cream-muted" data-id="element-332" data-mp="wta7liz6zv17">
              Kompletny system dla profesjonalnych pedagogów jazzu.
            </p>
            <p className="mt-5 font-serif text-base italic leading-snug text-cream-soft" data-id="element-333" data-mp="15sy9ig3xjyz8">
              Bo uczenie jazzu nie powinno kosztować Cię każdego wieczoru w tygodniu.
            </p>
          </div>
          <nav aria-label="Stopka" className="flex flex-col gap-3" data-id="element-334" data-mp="vv213w2dni4t">
            {links.map(({
            icon: Icon,
            label,
            href,
            external
          }) => <a key={label} href={href} {...external ? {
            target: '_blank',
            rel: 'noopener noreferrer'
          } : {}} className="flex items-center gap-3 text-sm text-cream-soft transition-colors duration-150 ease-out hover:text-amber" data-id="element-335" data-mp="1oh38la9n6vrp">
                <Icon className="h-4 w-4 text-amber" aria-hidden="true" data-id="element-336" data-mp="1jpl80nbj6x79" />
                {label}
              </a>)}
          </nav>
        </div>
        <p className="mt-10 border-t border-night-600 pt-6 text-[10px] uppercase tracking-label text-cream-muted sm:text-[11px]" data-id="element-337" data-mp="2c6xk9oi86ead">
          &copy; Arsenał Nauczyciela Jazzu&trade; 2026 &mdash; Wszelkie prawa zastrzeżone.
        </p>
      </div>
    </footer>;
}